import { Injectable } from '@angular/core';
import { getWindow } from 'ssr-window';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectorService {

  /**
   * Detects the operating system from the user agent string
   * @returns 'iOS' | 'Android' | 'Web' | undefined
   */
  getOS(): 'iOS' | 'Android' | 'Web' | undefined {
    const uA = getWindow().navigator.userAgent || getWindow().navigator.vendor;
    
    // Check for iOS devices
    if (/iPad|iPhone|iPod/.test(uA) || (uA.includes('Mac') && 'ontouchend' in document)) {
      return 'iOS';
    }
    
    // Check for other operating systems
    const os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
    for (let i = 0; i < os.length; i++) {
      if (new RegExp(os[i], 'i').test(uA)) {
        return os[i] === 'Android' ? 'Android' : 'Web';
      }
    }
    
    // Default to 'Web' for unmatched user agents (including Android Chrome)
    return 'Web';
  }

  /**
   * Check if the app is running in a native Android app context (not browser)
   * Native app has window.app object with native methods
   */
  isNativeApp(): boolean {
    return !!(window as any).app && typeof (window as any).app.reloadFromAndroid === 'function';
  }

  /**
   * Check if running on Android browser (not native app)
   */
  isAndroidBrowser(): boolean {
    return this.getOS() === 'Android' && !this.isNativeApp();
  }

  /**
   * Check if running on iOS device
   */
  isIOS(): boolean {
    return this.getOS() === 'iOS';
  }

  /**
   * Check if running on a mobile device (Android or iOS)
   */
  isMobile(): boolean {
    const os = this.getOS();
    return os === 'Android' || os === 'iOS';
  }

  /**
   * Check if running on desktop (Web)
   */
  isDesktop(): boolean {
    return this.getOS() === 'Web';
  }
}